import script from "./SchoolList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SchoolList.vue?vue&type=script&lang=ts&setup=true"

export default script